import { useScroll } from 'hooks/scroll';
import { throttle } from 'lodash';
import React, { useEffect, useRef, useState } from 'react';

export interface LazyShowProps {
    placeholderHeight: number;
    children: React.ReactElement;
}

export const LazyShow: React.FC<LazyShowProps> = (props) => {
    const { children, placeholderHeight } = props;
    const domRef = useRef<HTMLDivElement>(null);
    const [show, setShow] = useState(false);
    const showRef = useRef(show);

    const checkShow = () => {
        if (!domRef.current) {
            return;
        }
        const rect = domRef.current.getBoundingClientRect();
        const domOffsetTop = rect.top;
        const offsetY = window.screen.height - domOffsetTop;
        if (offsetY > 200) {
            showRef.current = true;
            dispose.current();
            setShow(true);
        } else {
            setShow(false);
        }
    };

    const dispose = useScroll(() => {
        if (!showRef.current) {
            requestAnimationFrame(checkShow);
        }
    }, 300);
    useEffect(() => {
        requestAnimationFrame(checkShow);
        const throttleCheck = throttle(checkShow, 200);
        window.addEventListener('resize', throttleCheck);
        return () => window.removeEventListener('resize', throttleCheck);
    }, []);

    return show ? (
        children
    ) : (
        <div ref={domRef} style={{ height: placeholderHeight, width: '100%' }}></div>
    );
};

export default React.memo(LazyShow);
